// @ts-nocheck

import { initKeyboardFocus } from '@theme/utilities';

let SAIL_globalEmail = '';

const SAIL_dom = {
  get input() {
    return document.getElementById('SAIL_inputWelcome');
  },
  get form() {
    return document.querySelector('.newsletter-form');
  },
  get contentForm() {
    return document.querySelector('.content-form');
  },
  get success() {
    return document.querySelector('.content-success');
  },
  get grabEmail() {
    return document.getElementById('SAIL_grabEmail');
  },
  get messageError() {
    return document.querySelector('.message-error');
  },
};

function validateAndSubmitForm() {
  const email = SAIL_dom.input?.value.trim() ?? '';
  const isValid = /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/i.test(email);

  if (isValid) {
    SAIL_globalEmail = email;
    SAIL_dom.messageError?.style.setProperty('display', 'none');
    SAIL_dom.input?.classList.remove('error');
    SAIL_dom.input?.classList.add('success');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'popup_pdp_welcome', popup_pdp_welcome_email: email });
    sessionStorage.setItem('welcome', email);
    SAIL_dom.contentForm?.style.setProperty('display', 'none');
    SAIL_dom.success?.style.setProperty('display', 'block');
    if (SAIL_dom.grabEmail) SAIL_dom.grabEmail.textContent = email;
  } else {
    SAIL_dom.messageError?.style.setProperty('display', 'flex');
    SAIL_dom.input?.classList.remove('success');
    SAIL_dom.input?.classList.add('error');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const form = SAIL_dom.form;
  if (!form) return;
  form.querySelectorAll('input, button').forEach((el) => {
    initKeyboardFocus(el, form);
  });
});

document.addEventListener('submit', (event) => {
  if (event.target.querySelector('#SAIL_inputWelcome')) {
    event.preventDefault();
    validateAndSubmitForm();
  }
});

document.addEventListener('input', (event) => {
  if (event.target.id === 'SAIL_inputWelcome' && event.target.value === '') {
    event.target.classList.remove('error');
    SAIL_dom.messageError?.style.setProperty('display', 'none');
  }
});
